<template>
  <span class="badge"><slot /></span>
</template>

<style scoped>
.badge {
  @apply text-sm inline-block px-1.5 text-slate-500 dark:text-zinc-400 bg-slate-100 dark:bg-zinc-600 rounded-full;
}
</style>
